export default __webpack_public_path__ + "static/media/cancel-button.131e92c2.svg";